import type { CallAdapter, DeviceKind, LocalMediaFailureReason } from '@/shared/lib/livekit'
import { mediaFailureReason, systemDefaultDeviceId } from '@/shared/lib/livekit'
import { toast } from '@/shared/ui/toast'
import { useDeviceSelection } from './device-store'

const DEVICE: Record<DeviceKind, string> = {
  audioinput: 'микрофон',
  videoinput: 'камеру',
  audiooutput: 'звук на выбранное устройство',
}

const CAUSE: Record<LocalMediaFailureReason, string> = {
  denied: 'доступ запрещён в настройках браузера',
  busy: 'устройство занято другим приложением',
  missing: 'устройства больше нет',
  unknown: 'устройство не отвечает',
}

function revert(kind: DeviceKind): void {
  const selection = useDeviceSelection.getState()
  if (kind === 'audioinput') selection.setMicId(undefined)
  else if (kind === 'videoinput') selection.setCamId(undefined)
  else selection.setOutputId(undefined)
}

// Применение выбора к живому звонку. Пустой выбор — не «ничего не делать», а
// системное устройство по умолчанию: после сброса пропавшей гарнитуры звук
// обязан вернуться, а не остаться на мёртвом железе. Отказ не глушим — откат на
// системное плюс причина словами: «микрофон не работает» человек сам не
// разгадает.
export async function applyDevice(
  adapter: CallAdapter | null,
  kind: DeviceKind,
  deviceId: string | undefined,
): Promise<void> {
  if (!adapter) return
  const target = deviceId ?? (await systemDefaultDeviceId(kind))
  if (target === undefined) return
  try {
    await adapter.switchDevice(kind, target)
  } catch (error) {
    // Отказало уже системное устройство — откатывать некуда, остаётся сказать.
    if (deviceId !== undefined) revert(kind)
    toast.error(`Не удалось включить ${DEVICE[kind]}: ${CAUSE[mediaFailureReason(error)]}`)
  }
}
